import React from 'react';
import loadable from '@loadable/component';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
const EmailCampaignComponent = loadable(
  () => import('../../components/EmailCampaign/EmailCampaign')
);
const EmailCampaign = () => {
  return (
    <>
      <div className={tw`pb-2`}>
        <h1 className={tw`text-lg font-semibold`}>Email Campaign</h1>
      </div>
      <EmailCampaignComponent />
    </>
  );
};

export default EmailCampaign;
